import { Injectable } from '@angular/core';
import { lastValueFrom, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  ATRC_DETAILS_API,
  LISTING_FINAL_RESPONSE,
  SITA_DETAILS_API,
  SIVI_DETAILS_API,
} from 'src/model/endpoints/service.endpoints';
import { environment } from 'environments/environment';
import { IFinalListingRequest } from 'src/model/requests/sic-ania/final-listing.request';
import { IFinalListingResponse } from 'src/app/pages/sic-ania/interfaces/search.interface';
import { UtilityService } from './utility.service';

const BASE_URL = environment.baseUrl;

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  //private environment = environment;
  constructor(
    private utilityService: UtilityService,
    private httpClient: HttpClient
  ) {}

  // last and listing api
  public async getFinalListingResponse(
    payload: IFinalListingRequest
  ): Promise<any | undefined> {
    if (environment.baseUrl.includes('localhost')) {
      return lastValueFrom(
        of(LISTING_FINAL_RESPONSE)
      );
    } else {
      return await lastValueFrom(
        this.httpClient.request<IFinalListingResponse | undefined>(
          'post',
          `${BASE_URL}/api/ania-service`,
          {
            body: {
              body: JSON.stringify(payload),
            },
            observe: 'body',
          }
        )
      );
    }
  }

  public async postDetails(
    body: any
  ): Promise<any | undefined> {
    if (environment.baseUrl.includes('localhost')) {
      let detailApi = {};
      //to remove when api will be working
      switch (body.mode) {
        case 'dettaglio-sivi':
          detailApi = SIVI_DETAILS_API;
          break;
        case 'dettaglio-sita':
          detailApi = SITA_DETAILS_API;
          break;
        case 'dettaglio-atrc':
          detailApi = ATRC_DETAILS_API;
          break;
        default:
      }
      return lastValueFrom(
        of(detailApi)
      );
    } else {
      return await lastValueFrom(
        this.httpClient.request<any | undefined>(
          'post',
          `${BASE_URL}/api/ania-service`,
          {
            body: body,
            observe: 'body',
          }
        )
      );
    }
  }
}
